var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowDoI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FEC10D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,54.1c0-3.5,1.4-6.5,3.8-9c1.7-1.8,2.5-3,2.5-4.9c0-1.4-1.3-2.9-3.6-2.9c-2.3,0-4.4,0.8-6.7,2.2l-2-8.1 c2.4-1.5,5.6-2.5,9.3-2.5c7.7,0,12.8,4.4,12.8,11c0,3.9-1.7,7-5.5,11.2c-1.6,1.8-2.3,3.4-2.3,5.2c0,0.9,0.1,2,0.3,2.9l-8.2-1.6 C40.1,56.2,39.9,55.2,39.9,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.7,61.7c2.9,0,5.4,2.4,5.4,5.4c0,2.9-2.5,5.4-5.4,5.4c-2.9,0-5.4-2.4-5.4-5.4 C39.3,64.1,41.7,61.7,44.7,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,16.5c-14.9,0-27,12.1-27,27c0,12.6,8.6,23.1,20.2,26.1c-0.3-0.8-0.5-1.6-0.5-2.5c0-1.5,0.5-3,1.2-4.1 c-8.3-2.6-14.4-10.3-14.4-19.5c0-11.2,9.1-20.4,20.4-20.4c11.2,0,20.4,9.1,20.4,20.4c0,9-5.9,16.7-14,19.3c0.8,1.2,1.3,2.7,1.3,4.3 c0,0.8-0.2,1.6-0.4,2.4c11.4-3.2,19.8-13.6,19.8-26C71.5,28.6,59.4,16.5,44.5,16.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowDoI);
export default __webpack_public_path__ + "static/media/how-do-i.26fc4010d0de675453801afbe60142be.svg";
export { ForwardRef as ReactComponent };